module.exports = __webpack_public_path__ + "img/external.e4170a55.svg";